import React, { useState } from 'react';
import '../../gutenberg.css';
import '../../App.css';
import '../contact.css' // Assuming you have a CSS file for styling
const ContactForm = () => {
  const [contactInfo, setContactInfo] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Ovde dodajte logiku za slanje forme
    console.log('Form submitted:', contactInfo);
    
    // Reset forme nakon slanja
    setContactInfo({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
<div>
  {/* Google Maps sekcija */}
  <section className="google-map">
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2780.836397516084!2d15.992344975154198!3d45.814534809997305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4765d657a9626b17%3A0x8be09df7ec1cb3f8!2sInstitut%20za%20menad%C5%BEment!5e0!3m2!1sen!2shr!4v1745429441550!5m2!1sen!2shr" 
      style={{ border: 0, width: '100%', height: '400px' }}
      allowFullScreen="" 
      loading="lazy" 
      referrerPolicy="no-referrer-when-downgrade"
    />
  </section>

  {/* Contact forma */}
  <div className="contact-container">
    <div className="contact-header">
      <h1>Kontaktirajte nas</h1>
      <p>Javite nam se - rado ćemo vam pomoći!</p>
    </div>
    
    <div className="contact-form">
      <div className="success-message" id="successMessage" style={{ display: 'none' }}>
        <h3>✓ Poruka je uspešno poslata!</h3>
        <p>Hvala vam na poruci. Odgovorićemo u najkraćem mogućem roku.</p>
      </div>
      
      <form id="contactForm" noValidate>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName" className="form-label">Ime</label>
            <input type="text" id="firstName" name="firstName" className="form-input" required />
            <div className="form-error" id="firstNameError"></div>
          </div>
          
          <div className="form-group">
            <label htmlFor="lastName" className="form-label">Prezime</label>
            <input type="text" id="lastName" name="lastName" className="form-input" required />
            <div className="form-error" id="lastNameError"></div>
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" id="email" name="email" className="form-input" required />
          <div className="form-error" id="emailError"></div>
        </div>
        
        <div className="form-group">
          <label htmlFor="subject" className="form-label">Naslov</label>
          <input type="text" id="subject" name="subject" className="form-input" required />
          <div className="form-error" id="subjectError"></div>
        </div>
        
        <div className="form-group form-group-full">
          <label htmlFor="message" className="form-label">Poruka</label>
          <textarea id="message" name="message" className="form-textarea" placeholder="Kako vam možemo pomoći..." required></textarea>
          <div className="form-error" id="messageError"></div>
        </div>
        
        <button type="submit" className="form-submit" id="submitBtn">
          Pošalji poruku
        </button>
      </form>
    </div>
  </div>
</div>
  );
};

export default ContactForm;